/**
 * Shared utility for aggregating compliance statuses
 */

// Status priority (lower number = worse status)
export const statusPriority: Record<string, number> = {
  missing: 1,
  expired: 2,
  buffer: 3,
  ok: 4,
  never_expires: 5,
};

export interface StatusNode {
  status: string | null;
  validUntil: string | null;
}

/**
 * Get worst status node from an array of status nodes
 * Returns both status and validUntil from the same node
 */
export const getWorstStatusNode = (nodes: StatusNode[]): StatusNode => {
  if (nodes.length === 0) return { status: null, validUntil: null };

  return nodes.reduce((worst, current) => {
    if (!worst.status) return current;
    if (!current.status) return worst;

    const worstPriority = statusPriority[worst.status] || 0;
    const currentPriority = statusPriority[current.status] || 0;

    // If same priority, prefer earliest validUntil (but only for non-missing statuses)
    if (currentPriority === worstPriority && currentPriority > 1) {
      if (!worst.validUntil) return current;
      if (!current.validUntil) return worst;
      return current.validUntil < worst.validUntil ? current : worst;
    }

    return currentPriority < worstPriority ? current : worst;
  });
};
